import React from 'react';

import heroBg from '../assets/hero-bg.webp';

const MainPageVideo = ({ className = '' }) => {
    return (
        <div className={`relative w-full h-full overflow-hidden ${className}`}>
            <img
                src={heroBg}
                alt=""
                role="presentation"
                fetchPriority="high"
                decoding="async"
                width={1920}
                height={1081}
                className="absolute inset-0 w-full h-full object-cover object-center scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/20" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40" />
        </div>
    );
};

export default MainPageVideo;
